import React, { useState } from "react";
import { api } from "../lib/api";
import { KurtMark } from "../components/KurtMark";
import { Loader2, LogIn } from "lucide-react";

export const Login = ({ onAuthed }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e?.preventDefault();
    setError("");
    setBusy(true);
    try {
      const user = await api.login(email.trim(), password);
      onAuthed(user);
    } catch (err) {
      setError(err.response?.data?.detail || "Couldn't sign you in. Check your details and try again.");
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100 flex items-center justify-center px-4">
      <div className="absolute inset-0 opacity-[0.4] pointer-events-none"
        style={{ background: "radial-gradient(600px circle at 30% 20%, rgba(16,185,129,0.10), transparent 40%), radial-gradient(700px circle at 80% 70%, rgba(16,185,129,0.06), transparent 45%)" }} />
      <form onSubmit={submit} data-testid="login-form"
        className="relative w-full max-w-sm rounded-3xl border border-white/10 bg-[#121824]/80 backdrop-blur-xl p-8 kz-fade-up">
        <div className="flex items-center gap-3 mb-7">
          <KurtMark size={40} />
          <div className="leading-none">
            <div className="kz-head font-extrabold text-xl tracking-tight">KURT<span className="text-emerald-400"> ZERO</span></div>
            <div className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mt-1">Operator console · S/ME</div>
          </div>
        </div>

        <h1 className="kz-head text-2xl font-extrabold mb-1">Sign in</h1>
        <p className="text-sm text-slate-400 mb-6">Your private console for running S/ME's growth.</p>

        <label className="block text-xs text-slate-400 mb-1.5">Email</label>
        <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          autoFocus placeholder="ben@smemagazine.co.uk"
          className="w-full bg-[#0B0F17] border border-white/10 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-emerald-500/40 mb-4" />

        <label className="block text-xs text-slate-400 mb-1.5">Password</label>
        <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          className="w-full bg-[#0B0F17] border border-white/10 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-emerald-500/40 mb-5" />

        {error && <p data-testid="login-error" className="text-sm text-red-400 mb-4">{error}</p>}

        <button data-testid="login-submit" type="submit" disabled={busy || !email || !password}
          className="w-full flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-emerald-500 text-[#04140d] font-semibold text-sm hover:bg-emerald-400 disabled:opacity-60 transition-all">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <LogIn size={16} />} Sign in
        </button>
      </form>
    </div>
  );
};
